import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash/fp';
import { get } from 'lodash';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
import RouteCollection from '@bd/bdcore-named-routes';
import { Slugify } from '@bd/bdcore-utilities';
import PageHelmet from '@bd/bdcore-pagehelmet';
import InsideHeader from '../../components/InsideHeader';
import PageWrapper from '../../components/PageWrapper';
import LightBoxPhotoList from '../../components/LightBoxPhotoList';
import MenuGalleries from './MenuGalleries';


const styles = css`
`;

function PhotoGallery({ page, router }) {
  const route = RouteCollection.getRouteByPath(_.get('location.pathname', router));
  const gallerySlug = _.get('params.gallery', route);
  let activeGallery;
  let photos = [];

  if (gallerySlug) {
    activeGallery = _.getOr([], 'photo_gallery', page)
      .find(g => Slugify(_.getOr('', 'categorie_name', g)) === gallerySlug);
    photos = _.getOr([], 'category_photos', activeGallery);
  } else {
    photos = _.flow(
      _.map('category_photos'),
      _.flatten,
    )(_.getOr([], 'photo_gallery', page));
  }

  return (
    <div className={styles}>
      <PageWrapper className={styles}>
        <PageHelmet page={page} />
        <InsideHeader
          h1={`${page.meta.name}`}
          background={get(page, 'page_image.contentUrl')}
        />
        <MenuGalleries
          page={page}
        />
        <LightBoxPhotoList
          show={12}
          gallery={_.get('categorie_name', activeGallery)}
          photos={photos}
        />
      </PageWrapper>
    </div>
  );
}

PhotoGallery.propTypes = {
  page: PropTypes.object.isRequired,
  router: PropTypes.object.isRequired,
};

export default withData({
  page: 'photo_gallery',
  router: true,
})(PhotoGallery);



// WEBPACK FOOTER //
// ./src/pages/PhotoGallery/index.js